import { ArrowLeft } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Header } from '@/components/Header'
import { BunkerDemoTour } from '@/components/marketing/BunkerDemoTour'
import { DEFAULT_LANGUAGE } from '@/lib/i18n'

/**
 * Full-page interactive bunker.ai product demo (built from the real product UI).
 * Reachable at /:lang/demo. Sized to fit the viewport so the page itself never
 * scrolls; the demo's controls + a clear "Zurück" link stay in view.
 */
export default function ProductDemoPage() {
  const { lang } = useParams<{ lang?: string }>()
  const { t } = useTranslation('home')
  const home = `/${lang || DEFAULT_LANGUAGE}`

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      <Header />
      <main className="flex min-h-0 flex-1 flex-col items-center px-4 pb-5 pt-20 sm:pt-24">
        <div className="mb-3 flex w-full max-w-7xl items-center">
          <Link
            to={home}
            className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-sm font-medium text-foreground transition-colors hover:border-primary hover:text-primary"
          >
            <ArrowLeft className="h-4 w-4" /> {t('productTour.back')}
          </Link>
        </div>
        <div className="min-h-0 w-full max-w-7xl flex-1">
          <BunkerDemoTour fillHeight />
        </div>
      </main>
    </div>
  )
}
